import styled from 'styled-components'

export const DatePickerUi = styled.div`
  flex: 1;

  .rw-widget-picker {
    grid-template: 1fr / 1fr 2.9em;
  }
  .rw-picker-btn {
    background-image: url("${process.env.EDITOR_ASSETS_HOST}/assets/images/toolbox/calendar.svg");
    background-position: center;
    background-repeat: no-repeat;
    border-left: none;
    svg {
      display: none;
    }
  }

  .rw-calendar {
    padding: 8px 16px 25px;
  }

  .rw-popup {
    border-radius: 6px;
  }
  .rw-calendar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border-bottom: 1px solid #e2e8f0;
  }

  .rw-calendar-btn-left {
    order: 1;
    margin-left: 0px;
    svg {
      fill: #cbd5e1;
    }
  }

  .rw-calendar-btn-view {
    order: 2;
    font-weight: normal;
    svg {
      display: none;
    }
  }

  .rw-calendar-btn-right {
    order: 3;
    svg {
      fill: #cbd5e1;
    }
  }

  .rw-calendar-btn-today {
    display: none;
  }

  .rw-calendar-head {
    color: #cbd5e1;
  }

  .rw-head-cell {
    border-bottom: none;
  }
  .rw-state-selected {
    background-color: var(--color-primary-500) !important;
    border-color: var(--color-primary-500) !important;
  }
`
